import {FC} from 'react';
import {TaskViewProvider} from './context/task_view.provider';
import TaskView from './TaskView';

const TaskViewWrapper: FC = () => (
  <TaskViewProvider>
    <TaskView />
  </TaskViewProvider>
);

export default TaskViewWrapper;
